import { TYPES } from '@/data/constants/product';
import { ProductType } from '@/data/types/Product';
import { replaceImagePath } from '@/utils/hdmPathConverter';
import { CDN_BASE_URL } from 'shared/custom/constants/commonConstants';
import { productIsA } from './productIsA';

const NO_IMAGE_BUNDLE = `${CDN_BASE_URL}/assets/img/imagen-no-disponible.svg`;

const getUrlFromList = (product: ProductType) => {
	const urls = product?.['attachments.url'];
	const urlList = Array.isArray(urls) ? urls : urls ? [urls] : [];

	return urlList.find((url) => url && !url.includes('-') && url.includes('.jpg'));
};

const getAttachmentPath = (product: ProductType) =>
	product.attachments?.find(
		(img) => img?.attachmentAssetPath && !img.attachmentAssetPath.includes('-')
	)?.attachmentAssetPath;

export const getProductThumbnail = (product: ProductType, sku?: ProductType | null): string => {
	const isBundle = productIsA(product, TYPES.bundle);

	if (isBundle) {
		const urlFromList = getUrlFromList(product);
		const imgPath = getAttachmentPath(product);

		return urlFromList || imgPath || NO_IMAGE_BUNDLE;
	}

	const defaultProductThumbnail = `${CDN_BASE_URL}/productos/${product.partNumber.replace(
		/[PB]/g,
		''
	)}/${product.partNumber.replace(/[PB]/g, '')}.jpg`;

	const baseImg = (sku ?? product).thumbnail;

	if (!baseImg) {
		const urlFromList = getUrlFromList(product);
		const assetPath = getAttachmentPath(product);

		const imgPath = urlFromList || assetPath;
		return imgPath ? replaceImagePath(imgPath) : defaultProductThumbnail;
	}

	return replaceImagePath(baseImg);
};
